/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../../../models/Node';
import { ValidationRule } from '../../ValidationRule';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends ValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasUnknownPropertyRule extends ValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitNode(io.apicurio.datamodels.core.models.Node)
     * @param {Node} node
     */
    visitNode(node : Node) {
        if(node.hasExtraProperties()) {
            node.getExtraPropertyNames().forEach((pname) => {
                this.report(node, pname, this.map("property", pname));
            });
        }
    }
}
OasUnknownPropertyRule["__class"] = "io.apicurio.datamodels.core.validation.rules.other.OasUnknownPropertyRule";
OasUnknownPropertyRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




